"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _FormButtonSubmit = _interopRequireDefault(require("../FormButtonSubmit"));

var _Form = require("../../../domains/registration/onboarding/shared/styles/Form");

var _forms = require("../../../helpers/forms");

var _helpers = require("./helpers");

var _RenderFields = _interopRequireDefault(require("./RenderFields"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;
var FormMessageStyled = (0, _styledComponents["default"])(_Form.FormMessage).withConfig({
  displayName: "DynamicForm__FormMessageStyled",
  componentId: "tfa1r9-0"
})(["margin:0 0 16px;"]);

var DynamicForm = function DynamicForm(_ref) {
  var formTheme = _ref.formTheme,
      formSize = _ref.formSize,
      formName = _ref.formName,
      renderSubmitButton = _ref.renderSubmitButton,
      fields = _ref.fields,
      fieldValues = _ref.fieldValues,
      formError = _ref.formError,
      isLoading = _ref.isLoading,
      biggerMargin = _ref.biggerMargin,
      handleOnSubmit = _ref.handleOnSubmit,
      onFilesRemoved = _ref.onFilesRemoved,
      hasSubmitHint = _ref.hasSubmitHint,
      submitButtonLabel = _ref.submitButtonLabel,
      enableReinitialize = _ref.enableReinitialize;
  var initialValues = (0, _helpers.getInitialValues)(fields, fieldValues);
  var validationSchema = (0, _forms.getValidationSchema)({
    fields: fields
  });

  var handleInternalSubmit = function handleInternalSubmit(props, formikBag) {
    // NOTE: In !1569, code was added to prevent double submits of forms.
    // This code caused faulty submits for select fields, so we've removed it
    // but kept this as a safeguard.
    if (!formikBag.isSubmitting) {
      return handleOnSubmit(props, formikBag);
    }

    return true;
  };

  return __jsx(_formik.Formik
  /**
   * Formik needs all fields to have initial value to get touched flag set (used for displaying errors) when firing onSubmit handler
   * read https://github.com/formium/formik/blob/34a11422bf1619236bc9fdb1b7c4f0d285638702/packages/formik/src/Formik.tsx#L98
   * For some use cases, fields list changes on rerender, so the initialValues;
   * but Formik doesn't take it into consideration if enableReinitialize is not set to true, and ends up not showing errors
   */
  , {
    enableReinitialize: enableReinitialize,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleInternalSubmit
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
        isSubmitting = _ref2.isSubmitting,
        values = _ref2.values,
        setFieldValue = _ref2.setFieldValue;
    return __jsx(_Form.VerticallyCenteredForm, {
      id: formName,
      "data-testid": formName,
      onSubmit: handleSubmit,
      noValidate: true
    }, __jsx(_styledComponents.ThemeProvider, {
      theme: {
        mode: formTheme,
        size: formSize
      }
    }, __jsx(_Form.InputsContainer, null, __jsx(_RenderFields["default"], {
      fields: fields,
      defaultValues: fieldValues,
      biggerMargin: biggerMargin,
      onFilesRemoved: onFilesRemoved,
      setFieldValue: setFieldValue,
      formValues: values
    })), formError && __jsx(FormMessageStyled, {
      error: true
    }, formError), renderSubmitButton && __jsx(_Form.SubmitContainer, null, __jsx(_FormButtonSubmit["default"], {
      formTheme: formTheme,
      hasSubmitHint: hasSubmitHint,
      isLoading: isLoading || isSubmitting,
      "data-testid": "".concat(formName, "-submit")
    }, submitButtonLabel))));
  });
};

DynamicForm.defaultProps = {
  formError: '',
  fieldValues: {},
  submitButtonLabel: 'Continue',
  hasSubmitHint: true,
  biggerMargin: false,
  enableReinitialize: false
};
var _default = DynamicForm;
exports["default"] = _default;